import { SidebarGroup, SidebarGroupLabel, SidebarMenu, SidebarMenuItem, SidebarMenuButton } from "@/components/ui/sidebar";
import { LayoutDashboard, Car, BanknoteArrowDown, ListCheck, BanknoteArrowUp } from "lucide-react";
import { useTranslate } from "react-admin";
import { NavLink } from "react-router-dom";

const LogisticMenu = () => {
  const translate = useTranslate();
  const navs = [
    {
      name: "Dashboard",
      url: "/",
      icon: LayoutDashboard,
    },
    {
      name: translate(`vehicles.name`, { smart_count: 2 }),
      url: "/vehicles",
      icon: Car,
    },
    {
      name: translate(`expenses.name`, { smart_count: 2 }),
      url: "/expenses",
      icon: BanknoteArrowDown,
    },
    {
      name: translate(`services.name`, { smart_count: 2 }),
      url: "/service",
      icon: ListCheck,
    },
    {
      name: translate(`incomes.name`, { smart_count: 2 }),
      url: "/incomings",
      icon: BanknoteArrowUp,
    },
  ];

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Logistic</SidebarGroupLabel>
      <SidebarMenu>
        {navs.map((item) => (
          <SidebarMenuItem
            key={item.name}
            className={`${item.url == location.pathname ? "bg-gray-200 dark:bg-neutral-600 rounded-lg" : ""}`}
          >
            <SidebarMenuButton className="text-[15px] font-medium" asChild>
              <NavLink to={item.url}>
                <item.icon />
                <span>{item.name}</span>
              </NavLink>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
};

export default LogisticMenu
